import { useCallback } from 'react';

import { useLocalSearchParams, useRouter } from 'expo-router';

import {
  CustomizeProductParams,
  IProductWizardFlow,
  NavigateToStepProps,
  ProductWizardParams,
  ProductWizardStep,
} from 'state/product-wizard-v2/types';
import { stringToBool } from 'utils/string-To-Bool';

export const useProductWizardFlow = (): IProductWizardFlow => {
  const params = useLocalSearchParams<ProductWizardParams>();
  const router = useRouter();

  const step = params.isProductReviewFromCart
    ? ProductWizardStep.ProductReview
    : ProductWizardStep.ProductHome;

  const {
    id = '',
    isEdit = false,
    cartIdEditing = '',
    isFavorite = false,
    isFromCart = false,
    isProductReviewFromCart = false,
    rewardBenefitId,
    rewardId,
    currentStep = step,
    slotKeyToCustomize = '',
  } = params || {};

  const navigateToStep = useCallback(
    (props: NavigateToStepProps) => {
      const updatedParams = {
        ...params,
        currentStep: props.step,
        slotKeyToCustomize: props.slotKey,
      };

      router.setParams(updatedParams);
    },
    [params, router]
  );

  const goToHome = useCallback(() => {
    navigateToStep({ step: ProductWizardStep.ProductHome });
  }, [navigateToStep]);

  const goToReviewProduct = useCallback(() => {
    navigateToStep({ step: ProductWizardStep.ProductReview });
  }, [navigateToStep]);

  const goToCustomizeProduct = useCallback(
    ({ step, slotKey }: CustomizeProductParams) => {
      navigateToStep({
        step,
        slotKey,
      });
    },
    [navigateToStep]
  );

  return {
    id,
    isEdit: stringToBool(isEdit),
    cartIdEditing,
    isFavorite: stringToBool(isFavorite),
    isFromCart: stringToBool(isFromCart),
    isProductReviewFromCart: stringToBool(isProductReviewFromCart),
    rewardBenefitId,
    rewardId,
    currentStep: Number(currentStep),
    slotKeyToCustomize,
    goToHome,
    goToCustomizeProduct,
    goToReviewProduct,
  };
};

export default useProductWizardFlow;
